const menuNames: { [key: string]: { name: string; route?: string; submenu?: { name: string; route: string }[] }[] } = {
  en: [
    { name: 'Home', route: '/' },
    {
      name: 'Activities',
      submenu: [
        { name: 'Good Reads', route: '/good-reads' },
        { name: 'Games & Contest', route: '/cyber-challenge' },
      ],
    },
    {
      name: 'GISP & Resources',
      submenu: [
        { name: 'GISP', route: '/tools-resources' },
        { name: 'Data Protection', route: '/data-protection' },
        { name: 'Digital Ethics', route: '/tools-resources' },
      ],
    },
    { name: 'Archives', route: '/Archives' },
    { name: 'Trainings', route: '/trainings' },
    { name: 'October Awareness Month', route: '/2026' },
    { name: 'FIFA', route: '/Fifa-theme' },
    { name: 'Training status', route: '/Training-Report' },
  ],
  es: [
    { name: 'Inicio', route: '/' },
    {
      name: 'Actividades',
      submenu: [
        { name: 'Buenas Lecturas', route: '/good-reads' },
        { name: 'Juegos y Concursos', route: '/cyber-challenge' },
      ],
    },
    {
      name: 'GISP y Recursos',
      submenu: [
        { name: 'GISP', route: '/tools-resources' },
        { name: 'Protección de Datos', route: '/data-protection' },
        { name: 'Ética Digital', route: '/tools-resources' },
      ],
    },
    { name: 'Archivos', route: '/Archives' },
    { name: 'Capacitación', route: '/trainings' },
    { name: 'Mes de Concienciación de Octubre', route: '/2026' },
  ],
  pt: [
    { name: 'Início', route: '/' },
    {
      name: 'Atividades',
      submenu: [
        { name: 'Boas Leituras', route: '/good-reads' },
        { name: 'Jogos e Concursos', route: '/cyber-challenge' },
      ],
    },
    {
      name: 'GISP e Recursos',
      submenu: [
        { name: 'GISP', route: '/tools-resources' },
        { name: 'Proteção de Dados', route: '/data-protection' },
        { name: 'Ética Digital', route: '/tools-resources' },
      ],
    },
    { name: 'Arquivos', route: '/Archives' },
    { name: 'Treinamentos', route: '/trainings' },
    { name: 'Mês de Conscientização de Outubro', route: '/2026' },
  ],
  zh: [
    { name: '首页', route: '/' },
    {
      name: '活动',
      submenu: [
        { name: '好书推荐', route: '/good-reads' },
        { name: '游戏和竞赛', route: '/cyber-challenge' },
      ],
    },
    {
      name: 'GISP 和资源',
      submenu: [
        { name: 'GISP', route: '/tools-resources' },
        { name: '数据保护', route: '/data-protection' },
        { name: '数字伦理', route: '/tools-resources' },
      ],
    },
    { name: '档案', route: '/Archives' },
    { name: '培训', route: '/trainings' },
    { name: '十月安全意识月', route: '/2026' },
  ],
};

export default menuNames;
